import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { Box} from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20,
    height: '90vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
  },
}));


/** 搜尋 - 底部選單手機版 */
export function SearchDrawer({Search, setSearchOpen}) {

  const classes = useStyles();


  return (
    <Box className={classes.root}>
      <Search setSearchOpen={setSearchOpen} />
    </Box>
  )
}